<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mt-5">
        <ul class="heading-ul mb-5">
          <li>
            <router-link :to="{ path: '/closing_entries' }" class="vx-row">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              <h4>{{ $t("accounting.label.viewclosure") }}</h4>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                        color="primary"
                        icon-pack="feather"
                        icon="icon-edit-2"
                        class="truncate"
                        @click="editData()"
                        size="small"
                        >{{ $t("setup.label.Edit") }}</vs-button
                      >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deletePopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("accounting.label.entityname") }}</b>
                </td>
                <td>{{ accountViewData.officeName }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("accounting.label.closuredate") }}</b>
                </td>
                <td>{{ getDate(accountViewData.closingDate) }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("accounting.label.closedby") }}</b>
                </td>
                <td>{{ accountViewData.createdByUsername }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("accounting.label.updatedby") }}</b>
                </td>
                <td>{{ accountViewData.lastUpdatedByUsername }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("accounting.label.updatedon") }}</b>
                </td>
                <td>{{ getDate(accountViewData.lastUpdatedDate) }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("accounting.label.closurecreationdate") }}</b>
                </td>
                <td>{{ getDate(accountViewData.createdDate) }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("accounting.label.comments") }}</b>
                </td>
                <td>{{ accountViewData.comments }}</td>
              </tr>
            </table>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deletePopup"
      title="Closure"
      @deletePressed="deleteClosure()"
      @cancelPressed="deletePopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
export default {
  data() {
    return {
      id: "",
      deletePopup: false,
    };
  },

  computed: {
    ...mapState({
      accountViewData: (state) => state.accounting.closureData,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    async getTemplateDataById() {
      try {
        await this.$store.dispatch(
          "accounting/getClosureDataByIdAction",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteClosure() {
      try {
        this.deletePopup = false;
        await this.$store.dispatch("accounting/deleteClosureAction", this.id);
        this.$router.push({ path: `/closing_entries` });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
      editData() {
        this.$router.push(`/closing_entries/edit_closure/${this.id}`);
      },
  },
  filters: {},
  async created() {
    this.id = this.$route.params.id;
    await this.getTemplateDataById();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
